import router from "@/router";
import api from "@/utils/api.js";
import responseHandler from "@/utils/responseHandler.js";
import { clearStorage, getItem, setItem } from "@/utils/storage.js";

//changes here line 8 - 16
export const login = async ({ }, payload) => {
	try {
		const response = await api.loginOrganisation(payload);
		const { data } = response.data;
		setItem("org_token", data.token);

		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};
export const setOrganisationProfile = ({ commit }, payload) => {
	commit("SET_ORGANISATION_DETAILS", payload);
};

export const setLoading = async ({ commit }, value) => {
	commit("SET_LOADING_STATE", value);
};

export const setPin = ({ commit }, payload) => {
	commit("SET_PIN", payload);
};

export const setCurrency = ({ commit }, payload) => {
	commit("SET_CURRENCY", payload);
};

export const setFundMethod = ({ commit }, payload) => {
	commit("SET_FUND_METHOD", payload);
};

export const setWithdrawMethod = ({ commit }, payload) => {
	commit("SET_WITHDRAW_METHOD", payload);
};

export const getOrganisationProfile = async ({ dispatch, commit }, payload) => {
	const orgInfo = getItem("org_details");
	const teamMember = getItem("team_member");
	const orgId = orgInfo ? orgInfo._id : null;
	dispatch("setLoading", true, { root: true });

	try {
		if (!payload && !orgId) {
			throw new Error("No organization ID available");
		}
		const response = await api.getOrganisationProfile(payload || orgId);

		if (!response || !response.data) {
			throw new Error("Invalid response from server");
		}
		const { data } = response.data;

		if (!data) {
			throw new Error("No organization data received");
		}

		setItem("org_details", data);

		if (teamMember && data?.teamMember) {
			setItem("team_member", data.teamMember);
			commit("SET_TEAM_MEMBER", data.teamMember);
		}

		dispatch("setOrganisationProfile", data);
		dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		clearStorage();
		router.push({ name: "SignIn" });
		dispatch("setLoading", false, { root: true });
		return false;
	} finally {
		dispatch("setLoading", false, { root: true });
	}
};

export const getOrganisationAsset = async ({ commit, dispatch }) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getOrganisationAsset();
		const { tokens } = response.data.data;
		commit("SET_ORGANISATION_ASSET", tokens);
		dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const updateOrgDetails = async ({ dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.updateOrganisationDetails(payload);
		const { data } = response.data;
		const profile = await dispatch("getOrganisationProfile", data._id);
		if (profile) return response;
		dispatch("setLoading", false, { root: true });
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		clearStorage();
		this.$router.push({ name: "SignIn" });
		return false;
	}
};

export const getCurrencyWallets = async ({ commit }) => {
	try {
		const response = await api.getCurrencyWallets();
		commit("SET_CURRENCY_WALLETS", response.data.data);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getWalletBalance = async ({ commit, dispatch }) => {
	// dispatch("setLoading", true, { root: true });
	try {
		const walletResponse = await api.getWalletBalance();
		const allBalances = walletResponse.data.data;
		commit("SET_WALLET_BALANCE", allBalances);
		// dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		// dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const getWalletTransaction = async ({ commit, dispatch }, payload) => {
	dispatch("setSmallLoading", true, { root: true });
	try {
		const response = await api.getWalletTransaction(payload);
		const { transactions, page, pages } = response.data.data;
		commit("SET_WALLET_TRANSACTION", transactions);
		commit("SET_WALLET_TRANSACTION_PAGE", page);
		commit("SET_WALLET_TRANSACTION_PAGES", pages);
		dispatch("setSmallLoading", false, { root: true });
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setSmallLoading", false, { root: true });
		return false;
	}
};

export const getTransactions = async ({ commit, dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		let response;
		if (payload.tokenId) {
			response = await api.getUserTransactions(payload);
		} else {
			response = await api.getTransactions(payload);
		}
		dispatch("setLoading", false, { root: true });
		const { data } = response.data;
		commit("SET_ORG_TRANSACTIONS", data.transactions);
		commit("SET_TRANSACTION_INFO", {
			page: data.page,
			pages: data.pages,
			total: data.total,
		});
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const getEntityCard = async ({ commit }) => {
	try {
		const response = await api.getEntityCard();
		const { data } = response.data;
		commit("SET_ENTITY_CARD", data);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getInvestmentCategories = async ({ commit }) => {
	try {
		const response = await api.getInvestmentCategories();
		const { data } = response.data;
		commit("SET_INVESTMENT_CATEGORIES", data);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getExchangeRate = async ({ commit, dispatch }, payload) => {
	dispatch("setSmallLoading", true, { root: true });
	try {
		const response = await api.getExchangeRate(payload);
		const { rate } = response.data.data;
		commit("SET_EXCHANGE_RATE", rate);
		dispatch("setSmallLoading", false, { root: true });
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setSmallLoading", false, { root: true });
		return false;
	}
};

export const submitKycDocument = async ({ dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.submitDocument(payload);
		const { data } = response.data;
		await dispatch("getOrganisationProfile", data[0].uploader);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return false;
	}
};

// Credit provider
export const createLoanConfiguration = async ({ dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.createLoanConfiguration(payload);
		const { data } = response.data;
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return false;
	}
};

// Every credit read is scoped to the selected currency. Taking it from state here
// rather than from each caller means a view cannot forget to pass it and quietly
// render a mixed-currency list beside a single-currency summary.
export const setCreditCurrency = ({ commit }, currency) => {
	commit("SET_CREDIT_CURRENCY", currency);
};

export const getLoans = async ({ commit, state }, query = {}) => {
	try {
		const response = await api.getCreditorLoans({
			currency: state.creditCurrency,
			...query,
		});
		const { docs, page, totalPages } = response.data.data;

		commit("SET_PAGE", page);
		commit("SET_PAGES", totalPages);
		commit("SET_LOANS", docs);

		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getBorrowers = async ({ commit, state }, query = {}) => {
	try {
		const response = await api.getBorrowers({
			currency: state.creditCurrency,
			...query,
		});
		const data = response.data.data;

		// Support both paginated ({ docs, page, totalPages }) and flat array responses
		const docs = Array.isArray(data) ? data : data.docs || [];

		commit("SET_BORROWERS", docs);

		if (!Array.isArray(data)) {
			commit("SET_B_PAGE", data.page || 1);
			commit("SET_B_PAGES", data.totalPages || 1);
		}

		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getLoanSummary = async ({ commit, state }, currency) => {
	try {
		const response = await api.getCreditorLoanSummary(
			currency || state.creditCurrency
		);
		const { data } = response.data;
		commit("SET_LOAN_SUMMARY", data);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getLoanConfiguration = async ({ commit }) => {
	try {
		const response = await api.getLoanConfiguration();
		const { data } = response.data;
		commit("SET_LOAN_CONFIGURATION", data);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const updateLoanConfiguration = async ({ commit, dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });

	try {
		const response = await api.updateLoanConfiguration(payload);
		const { data } = response.data;
		commit("SET_LOAN_CONFIGURATION", data);

		dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		responseHandler.handleError(error);

		dispatch("setLoading", false, { root: true });
		return false;
	}
};

export const getRefund = async ({ }, object) => {
	try {
		const response = await api.requestRefund(object);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};

export const generateQrCode = async ({ commit }, payload) => {
	try {
		const response = await api.generateQrCode(payload);
		const { data } = response.data;
		commit("SET_CODE", data);
		commit("SET_CODE_TYPE", payload);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const resetPasswordLink = async ({ }, payload) => {
	try {
		const response = await api.resetPasswordLink(payload);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const resetPassword = async ({ }, payload) => {
	try {
		const response = await api.resetPassword(payload);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getNotifications = async ({ }, payload) => {
	try {
		const response = await api.getNotifications(payload);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getTotalUnreadNotifications = async ({ commit }) => {
	try {
		const response = await api.getTotalUnreadNotifications();
		const { data } = response.data;
		commit("SET_NOTIFICATION_COUNT", data);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const markAllNotificationsRead = async ({ commit, dispatch }) => {
	try {
		await api.markAllNotificationsRead();
		commit("SET_NOTIFICATION_COUNT", 0);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getFeatures = async ({ commit, dispatch }) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getFeatures();
		const { data } = response.data;
		commit("SET_FEATURES", data);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		return error;
	}
};

export const subscribeToFeature = async ({ dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.subscribeToFeature({ products: payload });
		const { data } = response.data;
		setItem("org_details", data);
		dispatch("setLoading", false, { root: true });
		dispatch("setOrganisationProfile", data);
		return response;
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		return error;
	}
};

export const generateVirtualAccount = async ({ dispatch, commit }, payload) => {
	dispatch("setSmallLoading", true, { root: true });
	return new Promise((resolve, reject) => {
		api
			.generateVirtualAccount(payload)
			.then((response) => {
				const virtualAccount = response.data.data;
				commit("SET_VIRTUAL_ACCOUNT", virtualAccount);
				dispatch("setSmallLoading", false, { root: true });
				resolve(response);
			})
			.catch((error) => {
				console.log({ error });
				dispatch("setSmallLoading", false, { root: true });
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

export const getVirtualAccount = async ({ dispatch, commit }, payload) => {
	dispatch("setSmallLoading", true, { root: true });
	try {
		const response = await api.getVirtualAccount(payload);
		const { data } = response.data;
		commit("SET_VIRTUAL_ACCOUNT", data[0]);
		dispatch("setSmallLoading", false, { root: true });
		return true;
	} catch (error) {
		dispatch("setSmallLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const getVirtualAccountFee = async ({ }) => {
	// dispatch("setSmallLoading", true, { root: true });
	try {
		const response = await api.getVirtualAccountFee();
		// dispatch("setSmallLoading", false, { root: true });
		return true;
	} catch (error) {
		// dispatch("setSmallLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const getMinimumWithdrawal = async ({ commit }) => {
	try {
		const response = await api.getMinimumWithdrawal();
		const { data } = response.data;
		commit("SET_MINIMUM_WITHDRAWAL", Number(data));
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const verifyPin = async ({ commit }, payload) => {
	try {
		await api.verifyPin(payload);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getTokens = async ({ commit, dispatch }, payload) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getTokens(payload);
		const { data } = response.data;
		commit("SET_ORG_TOKENS", data.tokens);
		dispatch("setLoading", false, { root: true });
		return true;
	} catch (error) {
		dispatch("setLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const getOrganisationUpdate = async ({ commit, dispatch }, payload) => {
	dispatch("setSmallLoading", true, { root: true });
	try {
		const response = await api.getOrganisationUpdate(payload);
		const { tokenUpdates, updates, page, pages } = response.data.data;
		const flatTokenUpdate = tokenUpdates.flat();
		const totalUpdates = updates.reverse().concat(flatTokenUpdate.reverse());
		commit("SET_UPDATES", totalUpdates);
		// commit("SET_UPDATE_PAGE", page);
		// commit("SET_UPDATE_PAGES", pages);
		dispatch("setSmallLoading", false, { root: true });
		return true;
	} catch (error) {
		dispatch("setSmallLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const submitOrganisationUpdates = async (
	{ commit, dispatch },
	payload
) => {
	dispatch("setSmallLoading", true, { root: true });
	try {
		await api.submitOrganisationUpdates(payload);
		dispatch("setSmallLoading", false, { root: true });
		return true;
	} catch (error) {
		dispatch("setSmallLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};
export const getOrderBook = async ({ commit, dispatch }, payload) => {
	dispatch("setSmallLoading", true, { root: true });
	try {
		const response = await api.orderBook(payload);
		const { orders, total, page, pages } = response.data.data;
		commit("SET_ORDER_BOOK", orders);
		commit("SET_TOTAL_ORDERS", total);
		commit("SET_ORDER_PAGE", page);
		commit("SET_ORDER_PAGES", pages);
		dispatch("setSmallLoading", false, { root: true });
		return true;
	} catch (error) {
		dispatch("setSmallLoading", false, { root: true });
		responseHandler.handleError(error);
		return false;
	}
};

export const getTransactionFees = async ({ commit, dispatch }) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getTransactionFees();
		const { data } = response.data;
		commit("SET_TRANSACTION_FEES", data);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const tradeToken = async ({ }, payload) => {
	try {
		await api.tradeToken(payload);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};
export const deleteOrgFounder = async ({ dispatch }, founderId) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.deleteOrgFounder(founderId);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

//new updates
export const resetPin = async ({ }, pin) => {
	try {
		const response = await api.resetPin(pin);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};

export const getLastRaiseStage = async ({ dispatch, commit }) => {
	dispatch("setLoading", true, { root: true });
	try {
		const response = await api.getLastRaiseStage();
		const { data } = response;
		const lastStage = data.data.raise_stage;
		commit("SET_LAST_RAISE_STAGE", lastStage);
		dispatch("setLoading", false, { root: true });
		return response;
	} catch (error) {
		// responseHandler.handleError(error);
		dispatch("setLoading", false, { root: true });
		return error;
	}
};

export const activateMember = async ({ dispatch }, payload) => {
	try {
		const response = await api.activateMember(payload);
		const { message } = response.data;
		dispatch(
			"showToast",
			{ description: message, display: true, type: "success" },
			{ root: true }
		);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const deActivateMember = async ({ dispatch }, payload) => {
	try {
		const response = await api.deactivateMember(payload);
		const { message } = response.data;
		dispatch(
			"showToast",
			{ description: message, display: true, type: "success" },
			{ root: true }
		);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const pendingInvite = async ({ dispatch }, payload) => {
	try {
		const response = await api.pendingInvite(payload);
		const { message } = response.data;
		dispatch(
			"showToast",
			{ description: message, display: true, type: "success" },
			{ root: true }
		);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const getMinimumFunding = ({ commit }) => {
	return new Promise((resolve, reject) => {
		api
			.getMinimumFunding()
			.then((response) => {
				const { data } = response.data;
				commit("SET_MINIMUM_DEPOSIT", data);
				resolve(response);
			})
			.catch((error) => {
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

export const convertCurrency = ({ commit }, payload) => {
	return new Promise((resolve, reject) => {
		api
			.convertCurrency(payload)
			.then((response) => {
				const { amount } = response.data.data;
				commit("SET_CURRENCY_RATE", amount);
				resolve(response);
			})
			.catch((error) => {
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

export const convertWallet = async ({ }, payload) => {
	return new Promise((resolve, reject) => {
		api
			.convertWallet(payload)
			.then((response) => {
				resolve(response);
			})
			.catch((error) => {
				responseHandler.handleError(error);
				reject(error);
			});
	});
};

export const getTeamMembers = async ({ commit }, query) => {
	try {
		const response = await api.getTeamMembers(query);
		const {
			data: { data },
		} = response;
		commit("SET_TEAM_MEMBERS", data.docs);
		return response;
	} catch (error) {
		// responseHandler.handleError(error);
		return error;
	}
};

export const getIAMGroups = async ({ commit }) => {
	try {
		const response = await api.getIAMGroups();
		const {
			data: { data },
		} = response;
		commit("SET_ROLES", data?.iamGroups);
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return error;
	}
};

export const createIAMGroup = ({ dispatch, commit }, payload) => {
	dispatch("setLoading", true, { root: true });
	return new Promise((resolve, reject) => {
		api
			.createIAMGroup(payload)
			.then((response) => {
				dispatch("setLoading", false, { root: true });
				resolve(response);
			})
			.catch((error) => {
				responseHandler.handleError(error);
				dispatch("setLoading", false, { root: true });
				reject(error);
			});
	});
};


export const getTeamMember = async ({ dispatch }, payload) => {
	try {
		const response = await api.getTeamMember(payload);
		const { message } = response.data;
		// dispatch(
		// 	"showToast",
		// 	{ description: message, display: true, type: "success" },
		// 	{ root: true }
		// );
		return response;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const deleteTeamMember = async ({ dispatch }, payload) => {
	try {
		const response = await api.deleteTeamMember(payload);
		const { message } = response.data;
		dispatch(
			"showToast",
			{ description: message, display: true, type: "success" },
			{ root: true }
		);

		commit('REMOVE_TEAM_MEMBER', payload);

		return response;
	} catch (error) {
		// responseHandler.handleError(error);
		return false;
	}
};

export const editRole = async ({ dispatch }, payload) => {
	try {
		const response = await api.editRole(payload);
		const { message } = response.data;
		dispatch(
			"showToast",
			{ description: message, display: true, type: "success" },
			{ root: true }
		);
		return true;
	} catch (error) {
		responseHandler.handleError(error);
		return false;
	}
};

export const deleteRole = async ({ dispatch }, payload) => {
	try {
		const response = await api.deleteRole(payload);
		const { message } = response.data;
		dispatch(
			"showToast",
			{ description: message, display: true, type: "success" },
			{ root: true }
		);
		return true;
	} catch (error) {
		console.log(error, "err")
		responseHandler.handleError(error);
		return false;
	}
};

export const deleteMember = async ({ dispatch }, payload) => {
	try {
		const response = await api.deleteMember(payload);
		const { message } = response.data;
		dispatch(
			"showToast",
			{ description: message, display: true, type: "success" },
			{ root: true }
		);
		return true;
	} catch (error) {
		console.log(error, "err")
		responseHandler.handleError(error);
		return false;
	}
};

export const addMemberToTeam = ({ dispatch, commit }, payload) => {
	dispatch("setLoading", true, { root: true });
	return new Promise((resolve, reject) => {
		api
			.addMemberToTeam(payload)
			.then((response) => {
				dispatch("setLoading", false, { root: true });
				resolve(response);
			})
			.catch((error) => {
				responseHandler.handleError(error);
				dispatch("setLoading", false, { root: true });
				reject(error);
			});
	});
};

export const getTeamMemberInfo = ({ commit }, type) => {
	let teamMember = getItem("team_member");

	setItem("team_member", teamMember);
	commit("SET_TEAM_MEMBER", teamMember);
};

export const updateTeamMemberInfo = ({ commit }, type) => {
	let teamMember = getItem("team_member");

	if (!teamMember || typeof teamMember !== "object") {
		console.error("Invalid or missing team member data in localStorage.");
		return;
	}

	const updatedTeamMember = {
		...teamMember,
		two_factor_enabled: type === "activate",
	};

	setItem("team_member", updatedTeamMember);
	commit("SET_TEAM_MEMBER", updatedTeamMember);
};

export const addUserBvn = ({}, payload) => {
	return new Promise((resolve, reject) => {
		api
			.addUserBvn(payload)
			.then((response) => {
				resolve(response);
			})
			.catch((error) => {
				responseHandler.handleError(error);
				reject(error);
			});
	});
};
